// collection-header-scroll.js
// Handles the header background and color changes on scroll for collection pages

document.addEventListener('DOMContentLoaded', function() {
  initCollectionHeaderScroll();
  
  // In case of dynamic section loads (Shopify)
  document.addEventListener('shopify:section:load', function() {
    initCollectionHeaderScroll();
  });
});

function initCollectionHeaderScroll() {
  // Check if we're on a collection page using the body class
  const isCollectionPage = document.body.classList.contains('template-collection');
  
  if (!isCollectionPage) return;
  
  const headerWrapper = document.querySelector('.header-wrapper');
  if (!headerWrapper) return;
  
  // Get references to the logo elements
  const whiteLogos = document.querySelectorAll('.header__heading-logo--white');
  const blackLogos = document.querySelectorAll('.header__heading-logo--black');
  
  // Ensure the header wrapper isn't already being managed by another scroll handler
  headerWrapper.setAttribute('data-collection-header-managed', 'true');
  
  // Function to handle scroll behavior and logo switching
  function handleScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    
    // If we've scrolled past a certain threshold (50px), add the scrolled class
    if (scrollTop > 50) {
      headerWrapper.classList.add('scrolled-header');
      
      // Show black logo, hide white logo when scrolled
      whiteLogos.forEach(logo => logo.style.display = 'none');
      blackLogos.forEach(logo => logo.style.display = 'block');
      
      // Change icon and text colors to black
      updateHeaderColors('#000000', false);
    } else {
      headerWrapper.classList.remove('scrolled-header');
      
      // Check if drawer or mega menu is open
      const isDrawerOpen = headerWrapper.classList.contains('drawer-open');
      const isMegaMenuOpen = headerWrapper.classList.contains('mega-menu--open');
      
      // Only show white logo when header is transparent (not scrolled and no menu open)
      if (!isDrawerOpen && !isMegaMenuOpen) {
        whiteLogos.forEach(logo => logo.style.display = 'block');
        blackLogos.forEach(logo => logo.style.display = 'none');
        
        // Change icon and text colors to white
        updateHeaderColors('#ffffff', true);
      }
    }
  }
  
  // Helper function to update all header colors
  function updateHeaderColors(color, addTextShadow) {
    // Update icon colors
    const icons = headerWrapper.querySelectorAll('.header__icon svg, .header__icon span svg, .header__icon--cart svg, .header__icon--account svg, .header__icon--search svg, .header__icon--menu .svg-wrapper svg');
    icons.forEach(icon => {
      icon.style.color = color + ' !important';
      icon.style.fill = color + ' !important';
      icon.style.stroke = color + ' !important';
    });
    
    // Update cart, search, and menu drawer icon img filters for backward compatibility
    const cartIcons = headerWrapper.querySelectorAll('.header__icon--cart .svg-wrapper img');
    const searchIcons = headerWrapper.querySelectorAll('.header-search-icon');
    const menuIcons = headerWrapper.querySelectorAll('.header__icon--menu img');
    
    // Apply filter to all legacy image-based icons
    [].concat(...cartIcons, ...searchIcons, ...menuIcons).forEach(icon => {
      if (color === '#ffffff') {
        icon.style.filter = 'brightness(0) invert(1) !important';
      } else {
        icon.style.filter = 'none';
      }
    });
    
    // Update menu text colors
    const menuItems = headerWrapper.querySelectorAll('.header__menu-item, .header__active-menu-item');
    menuItems.forEach(item => {
      item.style.color = color + ' !important';
      if (addTextShadow) {
        item.style.textShadow = '0 0 1px rgba(0,0,0,0.5)';
      } else {
        item.style.textShadow = 'none';
      }
    });
  }
  
  // Remove existing scroll listeners to avoid conflicts
  window.removeEventListener('scroll', handleScroll);
  
  // Add scroll event listener
  window.addEventListener('scroll', handleScroll, { passive: true });
  
  // Run once on page load to set initial state
  handleScroll();
  
  // Also handle logo switching when drawer or mega menu is opened/closed
  const menuDrawerDetails = document.querySelector('#Details-menu-drawer-container');
  const megaMenus = document.querySelectorAll('.mega-menu');
  
  if (menuDrawerDetails) {
    // Watch for drawer open/close
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.attributeName === 'open') {
          handleScroll(); // Re-evaluate logo visibility
        }
      });
    });
    
    observer.observe(menuDrawerDetails, { attributes: true });
  }
  
  // Watch for mega menu open/close
  megaMenus.forEach(menu => {
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.attributeName === 'open') {
          handleScroll(); // Re-evaluate logo visibility
        }
      });
    });
    
    observer.observe(menu, { attributes: true });
  });
} 